import { Directive, DirectiveBinding } from 'vue'
import dayjs from 'dayjs'

function dateForm (el: HTMLElement, bindings: DirectiveBinding) {
  if (bindings.value) {
    let value = bindings.value
    let rule = 'YYYY-MM-DD HH:mm'
    if (typeof value !== 'number') {
      value = bindings.value.value
      rule = bindings.value.format || rule
    }
    el.innerText = dayjs(value).format(rule)
  }
}

/**
 * 时间格式化指令
 * @example
 * <span v-date-format="343243"></span>
 *
 * @example
 * <span v-date-format="{value: 434234, format: 'YYYY-MM-DD'}"></span>
 */
export const DateFormatDirective: Directive = {
  mounted (el: HTMLElement, bindings: DirectiveBinding) {
    dateForm(el, bindings)
  },
  updated (el: HTMLElement, bindings: DirectiveBinding) {
    dateForm(el, bindings)
  }
}
